(() => {
  'use strict';

  if (window.liftyPerformanceLoaderReady) return;
  window.liftyPerformanceLoaderReady = true;

  const selector = 'script[type="text/plain"][data-lifty-lazy-script]';
  const loaded = new Set();
  let started = false;

  const copyAttributes = (source, target) => {
    [...source.attributes].forEach(({ name, value }) => {
      if (name === 'type' || name === 'data-lifty-lazy-script' || name === 'data-lifty-src') return;
      target.setAttribute(name, value);
    });
  };

  const activateScript = (placeholder) => {
    const source = placeholder.dataset.liftySrc;
    if (!source || loaded.has(source)) {
      placeholder.remove();
      return;
    }

    loaded.add(source);
    const script = document.createElement('script');
    copyAttributes(placeholder, script);
    script.src = source;
    script.async = true;
    script.addEventListener('load', () => {
      document.dispatchEvent(new CustomEvent('lifty:third-party-loaded', { detail: { source } }));
    }, { once: true });
    script.addEventListener('error', () => loaded.delete(source), { once: true });
    placeholder.replaceWith(script);
  };

  const loadWidgets = () => {
    if (started) return;
    started = true;
    document.querySelectorAll(selector).forEach(activateScript);
  };

  const begin = () => {
    if ('requestIdleCallback' in window) {
      window.requestIdleCallback(loadWidgets, { timeout: 1200 });
    } else {
      window.setTimeout(loadWidgets, 1);
    }
  };

  ['pointerdown', 'touchstart', 'scroll', 'keydown', 'mousemove'].forEach((eventName) => {
    window.addEventListener(eventName, begin, { once: true, passive: eventName !== 'keydown' });
  });

  window.addEventListener('load', () => {
    window.setTimeout(begin, navigator.connection?.saveData ? 12000 : 6500);
  }, { once: true });

  document.addEventListener('shopify:section:load', () => {
    if (started) document.querySelectorAll(selector).forEach(activateScript);
  });

  document.addEventListener('lifty:load-third-party', loadWidgets);
})();
